import { apiRequest, apiStream } from './client';
import type { AiRepository } from '../../application/ports/AiRepository';
import type { AiSite } from '../../domain/Site';
import type { AiConversation, AiMessage, AiStreamHandlers, AiStreamResult, FieldAnalysis } from '../../domain/Ai';

export class HttpAiRepository implements AiRepository {
  listSites() {
    return apiRequest<{ sites: AiSite[] }>('/ai/sites');
  }

  listConversations(siteId: string) {
    return apiRequest<{ conversations: AiConversation[] }>(`/ai/conversations?siteId=${siteId}`);
  }

  createConversation(siteId: string) {
    return apiRequest<{ conversation: AiConversation }>('/ai/conversations', { method: 'POST', body: JSON.stringify({ siteId }) });
  }

  getConversation(id: string) {
    return apiRequest<{ conversation: AiConversation; messages: AiMessage[] }>(`/ai/conversations/${id}`);
  }

  async sendMessage(conversationId: string, question: string, handlers: AiStreamHandlers, signal?: AbortSignal) {
    let result: AiStreamResult | null = null;
    let error: string | null = null;
    await apiStream(
      `/ai/conversations/${conversationId}/messages`,
      { method: 'POST', body: JSON.stringify({ question }), signal },
      (event, data) => {
        const payload = data as { delta?: string; error?: string } & Partial<AiStreamResult>;
        if (event === 'reasoning' && payload.delta) handlers.onReasoning(payload.delta);
        else if (event === 'text' && payload.delta) handlers.onText(payload.delta);
        else if (event === 'done') result = payload as AiStreamResult;
        else if (event === 'error') error = payload.error ?? null;
      }
    );
    if (result) return result;
    throw new Error(error ?? 'No pudimos responder tu consulta.');
  }

  deleteConversation(id: string) {
    return apiRequest<void>(`/ai/conversations/${id}`, { method: 'DELETE' });
  }

  analyzeField(siteId: string) {
    return apiRequest<FieldAnalysis>('/ai/analyze', { method: 'POST', body: JSON.stringify({ siteId }) });
  }

  getDailySummary(siteId: string) {
    return apiRequest<{ summary: string }>('/ai/daily-summary', { method: 'POST', body: JSON.stringify({ siteId }) });
  }
}
